<template>
  <div>
    <!--添加巡检记录-->
    <el-dialog :visible.sync="addInspectRecordDialogVisible" title="添加巡检记录" @close="feedBack" v-if="addInspectRecordDialogVisible">
      <el-form label-width="100px" :model="AddInspectRecord.params" :ref="AddInspectRecord.params" :rules="rulesOfAddInspectRecord">
        <el-form-item label="巡检时间" prop="inspectTime">
          <el-date-picker type="datetime" v-model="AddInspectRecord.params.inspectTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="警报点编号" prop="alarmPointId">
          <!--<el-input v-model="AddReportRecord.params.alarmPointId"></el-input>-->
          <el-select placeholder="警报点" class="handle_input" v-model="AddInspectRecord.params.alarmPointId" @click="getAlarmPointList()"
                     filterable clearable style="width: 100%">
            <el-option
              v-for="item in alarmPointList"
              :label="item.pointName" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-card>
          <div class="itemTitle" >警报点节点信息</div>
          <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
            <!--<el-form-item label="编号">-->
            <!--<span >{{alarmPointInfo.alarmPointId}}</span>-->
            <!--</el-form-item>-->
            <div class="tonghang">
              <el-form-item label="点位名称">
                <span>{{AlarmPointStaticInfomation.pointName  === "" ? '无': AlarmPointStaticInfomation.pointName }}</span>
              </el-form-item>
              <el-form-item label="台站类型">
                <span>{{AlarmPointStaticInfomation.alarmPointType  === "" ? '无': AlarmPointStaticInfomation.alarmPointType }}</span>
              </el-form-item>
            </div>

            <div class="tonghang" >
              <el-form-item label="纬度">
                <span>{{AlarmPointStaticInfomation.longitude  === "" ? '无': AlarmPointStaticInfomation.longitude }}</span>
              </el-form-item>
              <el-form-item label="经度">
                <span>{{AlarmPointStaticInfomation.latitude  === "" ? '无': AlarmPointStaticInfomation.latitude }}</span>
              </el-form-item>
            </div>

            <div class="tonghang" >
              <el-form-item label="区域ID">
                <span>{{AlarmPointStaticInfomation.areaName === "" ? '无': AlarmPointStaticInfomation.areaName }}</span>
              </el-form-item>
              <el-form-item label="警音半径">
                <span>{{AlarmPointStaticInfomation.alarmRadius  === "" ? '无': AlarmPointStaticInfomation.alarmRadius }}</span>
              </el-form-item>
            </div>

            <div class="tonghang" >
              <el-form-item label="安装时间">
                <span>{{AlarmPointStaticInfomation.installAt  === "" ? '无': AlarmPointStaticInfomation.installAt }}</span>
              </el-form-item><br>
              <el-form-item label="备注">
                <span>{{AlarmPointStaticInfomation.remark  === "" ? '无': AlarmPointStaticInfomation.remark }}</span>
              </el-form-item>
            </div>

          </el-form>
          <div class="itemTitle" >警报器信息</div>
          <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
            <div class="tonghang">
              <el-form-item label="生产厂家">
                <span>{{alarmerInformation.producer  === "" ? '无': alarmerInformation.producer }}</span>
              </el-form-item>
              <el-form-item label="设备型号">
                <span>{{alarmerInformation.type  === "" ? '无': alarmerInformation.type }}</span>
              </el-form-item>
            </div>

            <div class="tonghang">
              <el-form-item label="版本">
                <span>{{alarmerInformation.version  === "" ? '无': alarmerInformation.version }}</span>
              </el-form-item>
              <el-form-item label="功率">
                <span>{{alarmerInformation.power === "" ? '无': alarmerInformation.power }}</span>
              </el-form-item>
            </div>

            <div class="tonghang">
              <el-form-item label="安装者">
                <span>{{alarmerInformation.installer === "" ? '无': alarmerInformation.installer }}</span>
              </el-form-item>
              <el-form-item label="安装时间">
                <span>{{alarmerInformation.installAt === "" ? '无': alarmerInformation.installAt }}</span>
              </el-form-item>
            </div>

            <div class="tonghang">
              <el-form-item label="备注">
                <span>{{alarmerInformation.remark === "" ? '无': alarmerInformation.remark }}</span>
              </el-form-item>
            </div>
          </el-form>
          <div class="itemTitle">警报控制器信息</div>
          <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
            <div class="tonghang">
              <el-form-item label="生产厂家">
                <span>{{alarmControllerInformation.producer === "" ? '无': alarmControllerInformation.producer }}</span>
              </el-form-item>
              <el-form-item label="通信体制">
                <span>{{alarmControllerInformation.communicationSystem === "" ? '无': alarmControllerInformation.communicationSystem }}</span>
              </el-form-item>
            </div>

            <div class="tonghang">
              <el-form-item label="版本">
                <span>{{alarmControllerInformation.version === "" ? '无': alarmControllerInformation.version }}</span>
              </el-form-item>
              <el-form-item label="地址码">
                <span>{{alarmControllerInformation.addressCode === "" ? '无': alarmControllerInformation.addressCode }}</span>
              </el-form-item>
            </div>
            <div class="tonghang">
              <el-form-item label="电台型号">
                <span>{{alarmControllerInformation.radioType === "" ? '无': alarmControllerInformation.radioType }}</span>
              </el-form-item>
              <el-form-item label="安装者">
                <span>{{alarmControllerInformation.installer === "" ? '无': alarmControllerInformation.installer }}</span>
              </el-form-item>
            </div>
            <div class="tonghang">
              <el-form-item label="安装时间">
                <span>{{alarmControllerInformation.installAt === "" ? '无': alarmControllerInformation.installAt }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{alarmControllerInformation.remark === "" ? '无': alarmControllerInformation.remark }}</span>
              </el-form-item>
            </div>
          </el-form>
          <div class="itemTitle" >物联网检测终端信息</div>
          <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
            <div class="tonghang">
              <el-form-item label="生产厂家">
                <span>{{monitorInformation.producer === "" ? '无': monitorInformation.producer }}</span>
              </el-form-item>
              <el-form-item label="安装者">
                <span>{{monitorInformation.installer === "" ? '无': monitorInformation.installer}}</span>
              </el-form-item>
            </div>

            <div class="tonghang">
              <el-form-item label="设备型号">
                <span>{{monitorInformation.type === "" ? '无': monitorInformation.type}}</span>
              </el-form-item>
              <el-form-item label="物联卡号">
                <span>{{monitorInformation.ICCID === "" ? '无': monitorInformation.ICCID}} </span>
              </el-form-item>
            </div>
            <div class="tonghang">
              <el-form-item label="安装时间">
                <span> {{monitorInformation.installAt === "" ? '无': monitorInformation.installAt}}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{monitorInformation.remark === "" ? '无': monitorInformation.remark}}</span>
              </el-form-item>
            </div>
          </el-form>
        </el-card>
        <el-form-item label="巡检结论" prop="inspectType" style="margin-top: 30px;">
          <!--<el-input v-model="AddReportRecord.params.alarmPointId"></el-input>-->
          <el-select placeholder="巡检结论" multiple class="handle_input" v-model="AddInspectRecord.params.inspectType"
                    filterable  clearable style="width: 100%">
            <el-option
              v-for="item in InspectContents.result.keyList"
              :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="巡检人" prop="inspectorId" style="margin-top: 30px;">-->
<!--          &lt;!&ndash;<el-input v-model="AddInspectRecord.params.inspectorId"></el-input>&ndash;&gt;-->
<!--          <el-select placeholder="巡检人" class="handle_input" v-model="AddInspectRecord.params.inspectorId" @click.native="getUserList"-->
<!--                     filterable clearable style="width: 100%">-->
<!--            <el-option-->
<!--              v-for="item in userList.result.userList"-->
<!--              :label="item.name"-->
<!--              :value="item._id"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="巡检内容" prop="inspectContent" style="margin-top: 30px;">
          <el-input type="textarea" :rows="2" v-model="AddInspectRecord.params.inspectContent"></el-input>
        </el-form-item>
      </el-form>
<!--      <el-button @click="fun">测试mixin方法</el-button>-->
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="checkAddInspectRecord">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  //import GetInspectContent from '../../../mixin/GetInspectContent'
  import {test, deepClone} from '../../../js/tool'

  export default {
    name: 'AddInspectRecord',
    props:['addInspectRecordDialogVisible'],
    //mixins: [GetInspectContent],
    data () {
      return {
        guzhangle:true,
        jiejuele: true,
        rulesOfAddInspectRecord:{
          inspectTime: [{required: true, message:'巡检时间不能为空', trigger: 'change'}],
          // inspectorId:[{required: true, message:'巡检人不能为空', trigger: 'change'}],
          inspectContent:[{required: true, message:'巡检内容不能为空', trigger: 'change'}],
          // inspectType:[{required: true, message:'巡检结论不能为空', trigger: 'change'}],
        },
        // 获取警报点列表
        GetAlarmPointList:{
          "version": 1,
          "method": "alarmpoint.GetPointNameList",
          "params": {
            // "pointName":null,
            // "alarmPointType":null,
            // "areaId":null
          },
          "token": "#",
          "id": 0
        },
        // 警报点列表
        alarmPointList:{
          "version": 1,
          "result":{
            "alarmPointList": [
              {
                "alarmPointId":  "",
                "pointName": "",
                "alarmPointType": "",
                "longitude": "",
                "latitude": "",
                "alarmRadius":"",
                "areaId":"",
                "installAt":"",
                "remark":""
              },
            ]
          },
          "id": 0
        },
        // 添加巡检记录
        AddInspectRecord:{
          "version": 1,
          "method": "inspect.AddInspectRecord",
          "params": {
            "alarmPointId": "",
            "inspectTime": "",
            "inspectorId":"",
            "inspectContent":"",
            "inspectType": ""
          },
          "token": "#",
          "id": 0
        },
        // 获取警报点列表
        // GetAlarmPointList:{
        //   "version": 1,
        //   "method": "alarmpoint.GetAlarmPointList",
        //   "params": {
        //     "pointName":null,
        //     "alarmPointType":null,
        //     "areaId":null
        //   },
        //   "token": "#",
        //   "id": 0
        // },
        // // 警报点列表
        // alarmPointList:{
        //   "version": 1,
        //   "result":{
        //     "alarmPointList": [
        //       {
        //         "alarmPointId":  "",
        //         "pointName": "",
        //         "alarmPointType": "",
        //         "longitude": "",
        //         "latitude": "",
        //         "alarmRadius":"",
        //         "areaId":"",
        //         "installAt":"",
        //         "remark":""
        //       },
        //     ]
        //   },
        //   "id": 0
        // },
        // 查看警报点静态信息
        GetStaticInformation:{
          "version": 1,
          "method": "alarmpoint2.GetStaticInformation",
          "params": {
            "alarmPointId":"#"
          },
          "token": "#",
          "id": 0
        },
        // 获取用户列表
        GetUserList:{
          "version": 1,
          "method": "user.GetUserList",
          "params": {
            "username":"",
            "name":"",
            "role":""
          },
          "token": "",
          "id": 0
        },
        // 账户列表
        userList:{
          "version": 1,
          "result":{
            "userList":[],
          },
          "id": 0
        },
        GetInspectContent:{
          "version":1,
          "method":"inspect.GetInspectContent",
          "params":{},
          "token":"d93d68299b",
          "id":0
        },
        InspectContents:{
          "version":"1.0",
          "result":{
            "keyList":[]
          },
          "id":0
        },
        // 警报点静态信息
        AltStaticInformation:{
          "version":"1.0",
          "result":{
            "_id":"5dc8d7dfd7693b3c280ee0a1",
            "areaId":"0601",
            "areaName":"",
            "pointName":"",
            "alarmPointType":"",
            "latitude":"",
            "longitude":"",
            "alarmRadius":"",
            "installAt":"",
            "deletedFlag":"",
            "remark":"",
            "devID":"",
            "monitorInformation":{
              "producer":"",
              "type":"",
              "ICCID":"",
              "installAt":"",
              "installer":"",
              "remark":"",
              "version":""
            },
            "alarmerInformation":{
              "producer":"",
              "type":"",
              "version":"",
              "power":"",
              "installer":"",
              "installAt":"",
              "remark":""
            },
            "alarmControllerInformation":{
              "producer":"",
              "communicationSystem":"",
              "version":"",
              "addressCode":"",
              "radioType":"",
              "installAt":"",
              "installer":"",
              "remark":""
            }
          },
          "id":0
        }
      }
    },
    methods: {
      // 获取警报点静态数据
      getStaticInfomation(){
        this.GetStaticInformation.token = this.$store.state.token;
        console.log('查看警报点静态信息请求');
        console.log(this.GetStaticInformation);
        this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res=>{
          console.log('查看警报点静态信息请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.AltStaticInformation = res.data.result;
          }else{
            this.$message({
              type:'error',
              message: '获取警报点信息失败，' + res.data.error.message
            })
          }
        })
      },
      GetInspectContent_handler(){
        this.GetInspectContent.token = this.$store.state.token;
        this.$axios.post(this.$mainUrl, this.GetInspectContent).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.InspectContents = res.data;
          }else{
            this.$message({
              type:'error',
              message: '获取警报点信息失败，' + res.data.error.message
            })
          }
        })
      },
      // 获取警报点列表
      getAlarmPointList(){
        for (let val in this.GetAlarmPointList.params){
          if(this.GetAlarmPointList.params[val] === ""){
            this.GetAlarmPointList.params[val] = null;
          }
        }
        // if(this.GetAlarmPointList.params.areaId !== null){
        //   this.GetAlarmPointList.params.areaId = this.GetAlarmPointList.params.areaId[this.GetAlarmPointList.params.areaId.length-1];
        // }
        this.GetAlarmPointList.token = this.$store.state.token;
        console.log('获取警报点列表请求');
        console.log(this.GetAlarmPointList);
        this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.alarmPointList = res.data.result.pointNameList;
          }
        })
      },
      feedBack(){
        this.cleanArguments(this.AddInspectRecord.params);
        this.resetValidate(this.AddInspectRecord.params);
        this.addInspectRecordDialogVisible = false;
        this.$emit('feedBack',this.addInspectRecordDialogVisible);
      },
      // 获取用户列表
      getUserList(){
        for(let key in this.GetUserList.params){
          if(this.GetUserList.params[key] === ""){
            this.GetUserList.params[key] = null;
          }
        }
        this.GetUserList.token = this.$store.state.token;
        console.log('获取用户列表请求');
        console.log(this.GetUserList);
        this.$axios.post(this.$mainUrl, this.GetUserList).then(res =>{
          console.log('获取用户列表请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.userList = res.data;
          }else{
            this.$message({
              type:'error',
              message:'获取用户列表失败，' + res.data.error.message
            })
          }
        })

      },
      checkAddInspectRecord(){
        this.$refs[this.AddInspectRecord.params].validate((valid)=>{
          if(valid){
            this.addInspectRecord();
          }
          else{
            return false;
          }
        })
      },
      addInspectRecord(){
        this.AddInspectRecord.token = this.$store.state.token;

        this.AddInspectRecord.params.inspectorId = localStorage.getItem('userId');
        let inspectType = deepClone(this.AddInspectRecord.params.inspectType);
        inspectType = inspectType.join(";");
        this.AddInspectRecord.params.inspectType = inspectType;
        // this.AddInspectRecord.params.inspectType =
        // this.AddInspectRecord.params.inspectorId = localStorage.getItem('userId');
        console.log('添加巡检记录请求');
        console.log(this.AddInspectRecord);
        this.$axios.post(this.$mainUrl, this.AddInspectRecord).then(res=>{
          console.log('添加巡检记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: '添加巡检记录成功'
            })
            this.feedBack();
          }
          else{
            this.$message({
              type: 'error',
              message: '添加巡检记录失败，' + res.data.error.message
            })
          }
        })
      }
    },
    watch:{
      'AddInspectRecord.params.alarmPointId'(newValue, oldValue){
        if(newValue !== null && newValue !== ""){
          // 为空则不用刷新
          this.GetStaticInformation.params.alarmPointId = newValue;
          this.getStaticInfomation();
        }
        else{
          Object.keys(this.AlarmPointStaticInfomation).forEach(key =>{
            if(key !== "alarmerInformation" && key !== "alarmControllerInformation" && key !== "monitorInformation"){
              this.AlarmPointStaticInfomation[key] = "";
            }
          })
          Object.keys(this.alarmerInformation).forEach(key =>{
            this.alarmerInformation[key] = "";
          })
          Object.keys(this.alarmControllerInformation).forEach(key =>{
            this.alarmControllerInformation[key] = "";
          })
          Object.keys(this.monitorInformation).forEach(key =>{
            this.monitorInformation[key] = "";
          })
        }

      }
    },
    computed:{
      AlarmPointStaticInfomation(){
        return this.AltStaticInformation;
      },
      alarmerInformation(){
        if(this.AltStaticInformation.hasOwnProperty('alarmerInformation')){
          return this.AltStaticInformation.alarmerInformation;
        }else{
          return {
            producer:'', type:'', version:'', power:'', installer:'', installAt:'', remark:''
          }
        }

      },
      alarmControllerInformation(){
        if(this.AltStaticInformation.hasOwnProperty('alarmControllerInformation')){
          return this.AltStaticInformation.alarmControllerInformation;
        }else{
          return {
            producer:'', communicationSystem:'', version:'', addressCode:'', radioType:'', installAt:'', installer:'', remark:''
          }
        }
      },
      monitorInformation(){
        if(this.AltStaticInformation.hasOwnProperty('monitorInformation')){
          return this.AltStaticInformation.monitorInformation;
        }else{
          return {
            producer:'', type:'', ICCID:'', installAt:'', installer:'', remark:''
          }
        }
      }
    },
    mounted () {
      this.GetInspectContent_handler()
      this.getAlarmPointList();
    }
  }
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .tonghang{
    display: flex;
    flex-wrap: nowrap;
  }
  .itemTitle{
    margin-top: 10px;
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 30px;
    font-family: 黑体;

  }
</style>
